module.exports = __webpack_public_path__ + "media/images/common/my_menu_mycatalog-6bb075f3eae8fc741fb65f92b9f85724.png";